import { ACCEPTED_DOCS_ID_TYPES, MAX_FILE_SIZE } from "../../config";
import { DateInput, FileInput } from "ra-ui-materialui";
import { DebouncedTextInput, Group, GroupTitle } from "ra-friendsofbabba";
import React, { Fragment } from "react";
import { required, useTranslate } from "ra-core";

import CompanyRepresentativeInput from "./CompanyRepresentativeInput";
import MediaField from "../../component/field/MediaField";
import classNames from "classnames";

const CompanyDelegatedInput = ({
  classes,
  source,
  representative,
  companyFieldLabel,
  requiredValidator,
  companyTypeId,
  type,
  ...props
}) => {
  const translate = useTranslate();
  if (companyTypeId <= 0) {
    return null;
  }
  return (
    <Group wrapper>
      <GroupTitle
        title={companyFieldLabel("delegated.title")}
        subTitle={companyFieldLabel("delegated.help")}
      />
      <CompanyRepresentativeInput
        {...props}
        source={`${source}.representative`}
        className={classNames(classes.inputBlock)}
        label={companyFieldLabel("representative")}
        validate={requiredValidator ? requiredValidator() : required()}
      />
      {representative === "delegated" && (
        <Fragment>
          <DebouncedTextInput
            {...props}
            className={classes.input}
            label={companyFieldLabel("delegated_name")}
            source={`${source}.delegated_name`}
            maxLength={100}
            validate={requiredValidator ? requiredValidator() : required()}
          />
          <DebouncedTextInput
            {...props}
            className={classes.input}
            label={companyFieldLabel("delegated_surname")}
            source={`${source}.delegated_surname`}
            maxLength={100}
            validate={requiredValidator ? requiredValidator() : required()}
          />
          <DateInput
            {...props}
            className={classes.input}
            label={companyFieldLabel("delegated_birth_date")}
            source={`${source}.delegated_birth_date`}
            validate={[requiredValidator ? requiredValidator() : required()]}
          />
          <DebouncedTextInput
            {...props}
            className={classes.input}
            label={companyFieldLabel("delegated_birth_city")}
            source={`${source}.delegated_birth_city`}
            maxLength={100}
            validate={requiredValidator ? requiredValidator() : required()}
          />
          <DebouncedTextInput
            {...props}
            className={classes.input}
            label={companyFieldLabel("delegated_role")}
            source={`${source}.delegated_role`}
            maxLength={100}
            validate={requiredValidator ? requiredValidator() : required()}
          />
          <FileInput
            source={`${source}.delegated_doc`}
            label={companyFieldLabel("delegated_doc")}
            helperText={translate(
              `resources.${props.resource}.fields.delegated_doc.help`,
              { acceptedFormats: ACCEPTED_DOCS_ID_TYPES.join(", ") }
            )}
            validate={requiredValidator ? requiredValidator() : required()}
            accept={ACCEPTED_DOCS_ID_TYPES.join(",")}
            maxSize={MAX_FILE_SIZE}
          >
            <MediaField source="filepath" title="filename" />
          </FileInput>
        </Fragment>
      )}
    </Group>
  );
};

export default CompanyDelegatedInput;
